// @flow
import {
  CREATE_MACHINE_SUCCESS,
  GET_MACHINE_SUCCESS,
} from './actionTypes';

const initialState = {};

const Machine = (state = initialState, action) => {
  switch (action.type) {
    case GET_MACHINE_SUCCESS:
      return action.payload;
    case CREATE_MACHINE_SUCCESS:
      return {
        data: action.payload,
      };

    default:
      return state;
  }
};

export default Machine;
